<div [id]="scriptContainerId" style="height:60vh; width: 50vw;"></div>
